import { SerializableObject } from '../../common-react/core';

import { FamilyMember } from './family-member.do';

/**
 * DTO Object for representing generic Addresses
 *
 * TODO: TP-9533 This object needs to match object from the backend.
 * @see mobiz-backend:UserProfileController.ChangeAddressOfFamilyMembers()
 * @deprecated This is an implementation detail of the address form and will be removed.
 */
export class AddressChange extends SerializableObject {
    // The family members to change address for
    familyMembers: FamilyMember[];

    // The streetname
    streetName: string;

    // Street number
    streetNumber: string;

    // Apartment number if it has one
    apartmentNumber?: string;

    // Postal code of address
    postalCode: string;

    // City of address
    city: string;

    // General comment about the new address
    additionalInformation: string;
}
